import { SpinAndHoldCommonConfiguration } from "../../../api";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { SpinAndHold2Params } from "../SpinAndHold/SpinAndHold2Params";
import { BigSymbolSpinAndHold2 } from "./BigSymbolSpinAndHold2";

export interface IBigSymbolSpinAndHoldBonusFactory2 {
	CreateBigSymbolSpinAndHold2(gameName: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration): BigSymbolSpinAndHold2;
}

export class BigSymbolSpinAndHoldBonusFactory2 implements IBigSymbolSpinAndHoldBonusFactory2 {

	public CreateBigSymbolSpinAndHold2(gameName: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration): BigSymbolSpinAndHold2 {
		return new BigSymbolSpinAndHold2(gameName, params, config);
	}
}